<template>
<div class="history" name="history">
  <topNav :title="title"></topNav>
  <div class="invoicehistory">
    <ul>
      <li>
        <div class="hiscontent">
            <h1>增值税电子普通发票</h1>
            <p><span>收款方：</span><span>城际停车支付信息有限公司</span></p>
            <p><span>付款方；</span><span>深圳市博西尼电子有限公司</span></p>
            <p><span>开票金额：</span><span>66.6</span>元</p>
            <p><span>开票时间：</span><span>2018-11-16</span>元</p>
        </div>
      </li>
    </ul>
  </div>
</div>

</template>
<script>
import topNav from "../topnav/topnav"
export default {
  name: 'paydetail',
  components:{
     topNav,
  },
  data() {
    return {
      title: "开票历史",
    }
  },
  methods:{
  },
  created(){
  }

}
</script>
<style>
.invoicehistory li{
  background: white;
  text-align: left;
  margin-bottom:7px;
}
.invoicehistory .hiscontent {
  margin: 0 8%;
  padding-bottom: 11px;
}
.invoicehistory  h1{
  padding: 12px 0;
}
.invoicehistory  p{
  padding: 4px 0;
  color:#a7a5a5;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/invoice/invoicehistory.vue